import { bootstrap } from '@zayouth/uikit/bootstrap'
import '@zayouth/uikit/styles/global.css'
import PortalShell from './AppShell.vue'
import { createPortalRouter } from './router'

bootstrap({ module: 'portal', shell: PortalShell, createRouter: createPortalRouter })
